import React from "react";
import { MotionConfig } from "framer-motion";
import { OfferProvider } from "./contexts/OfferContext";
import { SalesPage } from "./pages/SalesPage";
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3k9b1vu8xx9y1">
      <OfferProvider data-id="element-1" data-mp="3k89npgwmo7c3">
        <SalesPage data-id="element-2" data-mp="3k7i4z6o4q438" />
      </OfferProvider>
    </MotionConfig>;
}